/**
 * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
 * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
 *
 * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
 */

import { remToPx } from '@oat-sa-private/ui-core';

export const defaultGapSize = remToPx(10);
export const minGapSize = remToPx(5);
export const maxGapSize = remToPx(15);
